import { useEffect } from 'react';

import { scrollToTop } from 'helpers/utils';

export function useScrollToTop() {
    useEffect(() => {
        scrollToTop();
    }, []);
}
